import React, { Component } from "react";
import styles from "./Login.module.scss";
class Header extends Component {
  render() {
    return (
      <div className={styles[`tabsWrapper`]}>
        <div className={styles[`container`]}>
          <div className={styles[`top-header`]}>
            <div className={`${styles["left"]} ${styles["header-bar"]}`}>
              <div href="#" className={styles["logo"]} />

              {/* <!-- Tabs --> */}
              <ul className={styles["plan_tabs"]}>
                <li className={styles["selected"]}>
                  <a
                    href="https://www.airtel.in/about-bharti/about-bharti-airtel?icid=footer"
                    target="_blank"
                    rel="noreferrer"
                  >
                    About Airtel
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.airtel.in/help/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Get Help
                  </a>
                </li>
              </ul>
              {/* <!-- Tabs --> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
